
import React from 'react';
import { connect } from 'react-redux';
import cx from 'classnames';
import { createSelector } from 'reselect';
import * as yup from 'yup';

import { didPropChange } from 'utils/props';

import Account from 'store/models/Account';
import Campaign, { selectCampaignsByAccount } from 'store/models/Campaign';
import Brand, { selectBrandsByAccount } from 'store/models/Brand';
import { selectCurrentAccountId } from 'store/AppState';
import UIState from 'store/UIState';


import Modal, { ModalContent, ModalHeader, ModalTitle, ModalSubtitle, ModalActions } from 'components/Modal';
import { ErrorList } from 'components/forms/Error';
import Button from 'components/Button';
import ItemPicker, { CampaignItem } from 'components/ItemPicker';




// ======================
// STORE
// ====================== 
const actions = {
  fetchData: () => dispatch => Promise.all([
    dispatch(Campaign.actions.fetchCampaigns()),
    dispatch(Brand.actions.fetchBrands()),
  ]),

  closeModal: UIState.actions.closeModal,
  showModal: UIState.actions.showModal,
  
}

const selector = createSelector(
  state => selectCampaignsByAccount(state),
  state => selectBrandsByAccount(state),
  (campaigns, brands) => ({
    campaigns, 
    brands: _.keyBy(brands, '_id')
  })
);

const withConnect = connect(selector, actions);


// ======================
// COMPONENT
// ====================== 
class CampaignPickerModal extends React.Component {
  state = {
    selected: [],
  }

  componentDidMount() {
    this.props.fetchData();
    if(this.props.selectedId)
      this.setState({ selected: this.props.selectedId })
  }

  onCampaignChange = campaignId => this.setState({ selected: campaignId })

  onSave = () => {
    this.props.onSave?.(this.state.selected)
    this.props.closeModal();
  }

  render() {
    let { campaigns, brands, disabledIds, title, subtitle } = this.props;
    let { selected, notSelected, saving } = this.state;
    title = title ?? 'Select A Campaign';
    let selectCampaigns = _.reject(campaigns, c => _.includes(disabledIds, c._id))
    return (
      <Modal className="modal campaign-picker fill-vert s">
        <ModalHeader>
          <ModalTitle>{title}</ModalTitle>
          <ModalSubtitle>{subtitle}</ModalSubtitle>
        </ModalHeader>
        <ModalContent>
          <ItemPicker 
            selectMultiple={false}
            selectedItems={[selected]} 
            onSelectItem={this.onCampaignChange}>
            {_.map(selectCampaigns, campaign => {
              let brand = brands[campaign.brandId];
              return <CampaignItem key={campaign?._id} itemId={campaign?._id} campaign={campaign} brand={brand} />
            })}
          </ItemPicker>
        </ModalContent>
        <ModalActions>
          <Button
            onClick={this.onSave}
            disabled={saving}>Save</Button>
        </ModalActions>
      </Modal>);
  }
};

export default CampaignPickerModal
  |> withConnect
